import { supabase } from '@/integrations/supabase/client';
import type { Database } from '@/integrations/supabase/types';

type UserFeedback = Database['public']['Tables']['user_feedback']['Row'];
type UserFeedbackInsert = Database['public']['Tables']['user_feedback']['Insert'];

export const feedbackApi = {
  // Submit new feedback
  async submitFeedback(feedback: Omit<UserFeedbackInsert, 'user_id'>): Promise<UserFeedback> {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      throw new Error('User must be authenticated to submit feedback');
    }
    const user = session.user;

    const { data, error } = await supabase
      .from('user_feedback')
      .insert({
        ...feedback,
        user_id: user.id,
      })
      .select()
      .single();

    if (error) {
      throw new Error(`Failed to submit feedback: ${error.message}`);
    }

    return data;
  },

  // Get user's feedback history
  async getUserFeedback(): Promise<UserFeedback[]> {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) {
      throw new Error('User must be authenticated to view feedback');
    }
    const user = session.user;

    const { data, error } = await supabase
      .from('user_feedback')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });

    if (error) {
      throw new Error(`Failed to fetch feedback: ${error.message}`);
    }

    return data || [];
  },
};